import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { IdsModule } from 'src/app/ids.module';
import { CepPageComponent } from './cep.page';
import { HeaderModule } from '../../../shared/component/common/header/header.module';
import { ButtonModule } from '../../../shared/component/common/button/button.module';
import { LabelModule } from '../../../shared/component/common/label/label.module';
import { InputModule } from '../../../shared/component/common/input/input.module';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HeaderModule,
    ButtonModule,
    LabelModule,
    InputModule,
    ReactiveFormsModule,
    IdsModule
  ],
  declarations: [CepPageComponent]
})
export class CepPageModule {}
